import { createAsyncThunk } from '@reduxjs/toolkit';
import { RELATED_REPORT } from '../../constant';
import { getToken } from '../../Utils/authUtils';

export const uploadRelatedReportApi = createAsyncThunk(
  RELATED_REPORT.UPLOAD_PATIENT_PRESCRIPTION,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await fetch(RELATED_REPORT.UPLOAD_PATIENT_PRESCRIPTION, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Upload Prescription failed');
      }

      const result = await response.json();

      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
